export default __webpack_public_path__ + "static/media/locationMarker.59b8310d.svg";